<template>
  <div>
    <h1 class="h2 mt-4 mb-3">Material Shipment</h1>
    <div v-if="$store.getters.isLoaded(['materialShipments'])">
      <pre
        >{{ receiver.name1 }}
{{ contactPerson }}
{{ receiver.streetName }} {{ receiver.streetNumber }}
{{ receiver.zip }} {{ receiver.city }}
      </pre>
      <ul class="list-group mb-4">
        <li v-for="(item, itemType) in shipment.items" :key="itemType" class="list-group-item">
          <span v-if="item.amount">{{ item.amount }}x</span>
          <span>{{ itemType | startCase }} </span>
          <span v-if="itemType === 'sampleShipment' && shipment.type">({{ shipment.type | startCase }})</span>
        </li>
      </ul>
    </div>
    <Shipments :materialShipmentId="shipmentId" :contactPerson="contactPerson" :receiver="receiver" ref="shipments" />
    <div class="d-flex justify-content-end mt-5">
      <button class="btn btn-primary" @click="closeShipment">Close Order</button>
    </div>
  </div>
</template>

<script>
import Shipments from '@/components/Shipments'
import { db } from '@/shared/firebase'

export default {
  components: { Shipments },
  computed: {
    shipmentId() {
      return this.$route.params.shipmentId
    },
    shipment() {
      return this.$store.state.materialShipments.find(m => m.id === this.shipmentId)
    },
    receiver() {
      const receiver = _.cloneDeep(this.shipment.receiver)
      return {
        name1: receiver.name,
        name2: receiver.name2 || '',
        streetName: receiver.street,
        streetNumber: receiver.streetNumber,
        city: receiver.city,
        zip: receiver.zip,
        countryCode: 'DE'
      }
    },
    contactPerson() {
      return this.shipment.contactPerson
    }
  },
  methods: {
    closeShipment() {
      let confirmed = confirm('Close Shipment?')
      if (this.$refs.shipments.shipments.length === 0) {
        confirmed = false
        confirmed = confirm(`WARNING: The Order has no shipments! Are you sure you wan't to close it?`)
      }
      if (confirmed) {
        db.doc(`materialShipments/${this.shipmentId}`)
          .update({
            shipped: true,
            shippedAt: new Date()
          })
          .then(() => {
            this.$router.push({ name: 'materialShipments' })
          })
      }
    }
  },
  filters: {
    date(date) {
      return date.toLocaleString('de-DE', { hour: '2-digit', minute: '2-digit', month: '2-digit', day: '2-digit' })
    },
    startCase(str) {
      return _.startCase(str)
    }
  }
}
</script>
